import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-row mt-4 gap-x-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_3 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_4 = { class: "flex flex-row mt-4" }
const _hoisted_5 = { class: "w-full mr-4" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_8 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_10 = { class: "w-1/2 flex flex-row mb-6 mt-0" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = { class: "flex flex-row" }
const _hoisted_14 = { class: "mx-2" }
const _hoisted_15 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_17 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-row my-6"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_20 = { class: "w-1/2 ml-6" }
const _hoisted_21 = { class: "flex flex-row text-12px xxl:text-14px relative" }
const _hoisted_22 = { class: "w-1/2 mr-4" }
const _hoisted_23 = { class: "p-field-checkbox mt-3" }
const _hoisted_24 = { class: "w-1/2" }
const _hoisted_25 = { class: "p-field-checkbox mt-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "py-3 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }, " Jenis pengiriman tidak tersedia karena terjadi embargo. ", -1)
const _hoisted_30 = {
  key: 1,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_31 = { class: "text-14px" }
const _hoisted_32 = {
  key: 2,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_33 = { class: "text-14px" }
const _hoisted_34 = { class: "flex flex-row mt-4 space-x-4" }
const _hoisted_35 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000 flex gap-x-2 pl-1"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_37 = { class: "flex flex-row mt-4 space-x-4" }
const _hoisted_38 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000 flex gap-x-2 pl-1"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Status pengiriman wajib diisi ")
const _hoisted_41 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_42 = { class: "w-1/2 pr-3" }
const _hoisted_43 = { class: "flex flex-row text-12px xxl:text-14px relative mt-4 space-x-4" }
const _hoisted_44 = { for: "cod" }
const _hoisted_45 = { class: "flex flex-row text-12px xxl:text-14px mt-4 space-x-4 items-center" }
const _hoisted_46 = { class: "w-1/2" }
const _hoisted_47 = { class: "flex flex-col bg-gray-lp-700 my-6 py-6 rounded-md" }
const _hoisted_48 = { class: "flex w-full gap-x-6 border-b border-gray-lp-400 py-5 flex-row gap-x-6text-black-lp-300 font-semibold text-12px xxl:text-14px" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 text-center" }, " No ", -1)
const _hoisted_50 = { class: "w-3/12" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "w-4/12" }, [
  /*#__PURE__*/_createTextVNode(" Dimensi/Paket "),
  /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (P x L x T)"),
  /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*")
], -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, " Berat Volume ", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_54 = { class: "flex w-full items-center gap-x-6 py-2 text-12px xxl:text-14px font-montserrat" }
const _hoisted_55 = { class: "w-1/12 text-center" }
const _hoisted_56 = { class: "w-3/12" }
const _hoisted_57 = { class: "w-4/12" }
const _hoisted_58 = { class: "w-2/12" }
const _hoisted_59 = { class: "w-2/12" }
const _hoisted_60 = { class: "flex w-full flex-row justify-start gap-x-6" }
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_62 = { class: "w-9/12 flex flex-row px-4 py-2 rounded-md warningMinimumWeight ml-2 mr-32" }
const _hoisted_63 = { class: "text-gray-lp-300 text-12px font-normal" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_65 = { class: "flex w-full flex-row justify-start gap-x-6" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_67 = { class: "w-9/12 flex flex-row" }
const _hoisted_68 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_69 = { class: "text-red-lp-100 text-12px xxl:text-14px flex gap-x-2" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_71 = { class: "my-5" }
const _hoisted_72 = {
  key: 1,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 pt-2"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 2,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 pt-2"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("span", null, " Maksimal Berat 5 Kg ", -1)
const _hoisted_79 = {
  key: 3,
  class: "flex flex-row justify-between text-12px xxl:text-14px px-6 my-6"
}
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Tambah Barang ")
const _hoisted_81 = { class: "flex flex-col justify-around w-full" }
const _hoisted_82 = { class: "flex flex-row justify-between text-gray-lp-300 font-semibold text-12px xxl:text-14px" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Total Barang ")
const _hoisted_84 = { class: "flex flex-col" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Total Berat Kotor ")
const _hoisted_86 = { class: "flex flex-col" }
const _hoisted_87 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-700 font-normal mb-2 text-12px xxl:text-14px" }, " Total berat barang melebihi batas maksimum yaitu 400 Kg/STT ", -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_89 = { class: "flex flex-col" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Total Berat Dimensi ")
const _hoisted_91 = { class: "flex flex-col" }
const _hoisted_92 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-700 font-normal mb-2 text-12px xxl:text-14px" }, " Total berat barang melebihi batas maksimum yaitu 400 Kg/STT ", -1)
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_94 = /*#__PURE__*/_createVNode("div", { class: "border-t-2 mt-4" }, null, -1)
const _hoisted_95 = { class: "flex flex-row justify-between text-gray-lp-300 font-semibold text-12px xxl:text-14px mt-4" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Berat Dikenakan Biaya ")
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_98 = { class: "flex flex-row mt-4" }
const _hoisted_99 = { class: "w-full mr-2" }
const _hoisted_100 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_101 = /*#__PURE__*/_createVNode("p", null, " Piece Per Pack ", -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_103 = { class: "ml-1 relative" }
const _hoisted_104 = { class: "w-full ml-2" }
const _hoisted_105 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_106 = /*#__PURE__*/_createVNode("p", null, " Komoditas Selanjutnya ", -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_108 = { class: "ml-1 relative" }
const _hoisted_109 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_110 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-700 border-b-2 border-gray-lp-400 mb-4 pb-4"
}
const _hoisted_111 = { class: "items-center justify-end flex flex-row" }
const _hoisted_112 = /*#__PURE__*/_createVNode("h2", { class: "text-14px pt-5 text-black-lp-300 font-bold" }, " Total Pembayaran ", -1)
const _hoisted_113 = { class: "flex items-center justify-center py-3" }
const _hoisted_114 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_115 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_LpInputSearch = _resolveComponent("LpInputSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ErrorMessageBooking = _resolveComponent("ErrorMessageBooking")!
  const _component_WarningSlaTransportation = _resolveComponent("WarningSlaTransportation")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BannerProductType = _resolveComponent("BannerProductType")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Woodpacking = _resolveComponent("Woodpacking")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InformationCodRetail = _resolveComponent("InformationCodRetail")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_DetailCalculation = _resolveComponent("DetailCalculation")!
  const _component_DetailUncalculation = _resolveComponent("DetailUncalculation")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ModalV2, {
      width: "w-9/12",
      title: 
      `${_ctx.indexElement + 1} - ${
        _ctx.isCourierRecommendation
          ? _ctx.detailShipment.shipmentNoRefExt
          : _ctx.detailShipment.shipmentAlgoId
      }`
    ,
      onClose: () => _ctx.setEditTerminated(true)
    }, {
      content: _withCtx(() => [
        _createVNode(_component_Title, { label: "Detail Pengiriman" }),
        _withDirectives(_createVNode("div", null, _toDisplayString(_ctx.index), 513), [
          [_vShow, false]
        ]),
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            class: "w-full mr-4",
            label: "Shipment ID",
            tooltipTitle: "Shipment ID",
            tooltipDescription: "Isi Shipment ID dengan kode booking marketplace yang tertera pada paket (XYZ00xxx)."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                isFirstInput: true,
                disabled: true,
                modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentAlgoId = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "No. Referensi Eksternal",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.shipmentNoRefExt,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shipmentNoRefExt = $event)),
                placeholder: "DOR00989",
                disabled: 
              _ctx.detailShipment.shipmentAlgoId.slice(0, 2) === 'DO'
                ? false
                : _ctx.disabledInput
            ,
                errorCaption: "Mohon isi No. Referensi Eksternal",
                showMaxLength: true,
                maxLength: 100
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            label: "Nama Pengirim",
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              (_ctx.urlVersion === 'v2')
                ? (_openBlock(), _createBlock(_component_SelectSearch, {
                    key: 0,
                    isDisabled: _ctx.handleDisabledInput,
                    class: "my-2",
                    options: _ctx.senders,
                    onFilter: _cache[3] || (_cache[3] = e => _ctx.setNameCustomer(e, 'senders')),
                    onFocus: _cache[4] || (_cache[4] = 
              e => {
                _ctx.setFieldIndex(3);
              }
            ),
                    placeholder: "Masukan nama pengirim",
                    isShowErrorIndicator: _ctx.errorMandatory[3],
                    errorCaption: _ctx.errorMandatory[3] ? 'Nama pengirim wajib diisi' : '',
                    onChange: _ctx.onChooseSenders,
                    keyName: "customerName",
                    keyValue: "customerName",
                    isLoading: _ctx.isLoadingCustomer,
                    modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentSenderName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentSenderName = $event))
                  }, null, 8, ["isDisabled", "options", "isShowErrorIndicator", "errorCaption", "onChange", "isLoading", "modelValue"]))
                : (_openBlock(), _createBlock(_component_LpInputSearch, {
                    key: 1,
                    isDisabled: _ctx.handleDisabledInput,
                    class: "my-2",
                    options: _ctx.senders,
                    onFilter: _cache[6] || (_cache[6] = e => _ctx.setNameCustomer(e, 'senders')),
                    onInputFilter: _cache[7] || (_cache[7] = e => _ctx.setCustomer(e, 'senders')),
                    onFocus: _cache[8] || (_cache[8] = 
              e => {
                _ctx.setFieldIndex(3);
              }
            ),
                    isLoading: _ctx.isLoadingCustomer,
                    keyName: "customerName",
                    secondKeyName: "customerPhoneNumber",
                    keyValue: "customerName",
                    onChange: _ctx.onChooseSenders,
                    placeholder: "Masukan nama pengirim",
                    isShowErrorIndicator: _ctx.errorMandatory[3],
                    errorCaption: _ctx.errorMandatory[3] ? 'Nama pengirim wajib diisi' : '',
                    modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentSenderName,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentSenderName = $event)),
                    maxLength: 250
                  }, null, 8, ["isDisabled", "options", "isLoading", "onChange", "isShowErrorIndicator", "errorCaption", "modelValue"]))
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Nama Penerima",
            asterisk: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              (_ctx.urlVersion === 'v2')
                ? (_openBlock(), _createBlock(_component_SelectSearch, {
                    key: 0,
                    isDisabled: 
              _ctx.isShipmentCASameday
                ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientNameKeeped.length
                : _ctx.handleDisabledInput
            ,
                    class: "my-2",
                    options: _ctx.receivers,
                    onFilter: _cache[10] || (_cache[10] = e => _ctx.setNameCustomer(e, 'receivers')),
                    onFocus: _cache[11] || (_cache[11] = 
              e => {
                _ctx.setFieldIndex(4);
              }
            ),
                    placeholder: "Masukan nama penerima",
                    isShowErrorIndicator: _ctx.errorMandatory[4],
                    errorCaption: _ctx.errorMandatory[4] ? 'Nama penerima wajib diisi' : '',
                    onChange: _ctx.onChooseReceivers,
                    keyName: "customerName",
                    keyValue: "customerName",
                    isLoading: _ctx.isLoadingCustomer,
                    modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientName,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentRecipientName = $event))
                  }, null, 8, ["isDisabled", "options", "isShowErrorIndicator", "errorCaption", "onChange", "isLoading", "modelValue"]))
                : (_openBlock(), _createBlock(_component_LpInputSearch, {
                    key: 1,
                    isDisabled: 
              _ctx.isShipmentCASameday
                ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientNameKeeped.length
                : _ctx.handleDisabledInput
            ,
                    class: "my-2",
                    options: _ctx.receivers,
                    onFilter: _cache[13] || (_cache[13] = e => _ctx.setNameCustomer(e, 'receivers')),
                    onInputFilter: _cache[14] || (_cache[14] = e => _ctx.setCustomer(e, 'receivers')),
                    onFocus: _cache[15] || (_cache[15] = 
              e => {
                _ctx.setFieldIndex(4);
              }
            ),
                    isLoading: _ctx.isLoadingCustomer,
                    keyName: "customerName",
                    secondKeyName: "customerPhoneNumber",
                    keyValue: "customerName",
                    onChange: _ctx.onChooseReceivers,
                    placeholder: "Masukan nama penerima",
                    isShowErrorIndicator: _ctx.errorMandatory[4],
                    errorCaption: _ctx.errorMandatory[4] ? 'Nama penerima wajib diisi' : '',
                    modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientName,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentRecipientName = $event)),
                    maxLength: 250
                  }, null, 8, ["isDisabled", "options", "isLoading", "onChange", "isShowErrorIndicator", "errorCaption", "modelValue"]))
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              label: "No. Telepon Pengirim",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "Pengirim",
                  error: _ctx.errorPhoneSender,
                  phone: _ctx.shipmentList[_ctx.indexElement].shipmentSenderPhone,
                  code: _ctx.shipmentList[_ctx.indexElement].shipmentSenderPhoneCode,
                  flag: _ctx.shipmentList[_ctx.indexElement].shipmentSenderPhoneFlag,
                  onSetPhone: _ctx.setPhoneSender,
                  onSetPhoneCode: _ctx.setPhoneCodeSender,
                  onSetPhoneFlag: _ctx.setPhoneFlagSender,
                  onSetErrorPhone: _ctx.setErrorPhoneSender,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneCodeSender,
                  disabled: _ctx.handleDisabledInput,
                  onSetErrorCharMinimal: _ctx.setErrorCharMinimalSender,
                  onSetFieldIndex: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setFieldIndex(5)))
                }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhone", "onSetErrorPhoneCode", "disabled", "onSetErrorCharMinimal"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              label: "No. Telepon Penerima",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "Penerima",
                  error: _ctx.errorPhoneReceiver,
                  phone: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhone,
                  code: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhoneCode,
                  flag: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhoneFlag,
                  onSetPhone: _ctx.setPhoneReceiver,
                  onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                  onSetPhoneFlag: _ctx.setPhoneFlagReceiver,
                  onSetErrorPhone: _ctx.setErrorPhoneReceiver,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneCodeReceiver,
                  disabled: 
                _ctx.isShipmentCASameday
                  ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhoneKeeped
                      .length
                  : _ctx.handleDisabledInput
              ,
                  onSetErrorCharMinimal: _ctx.setErrorCharMinimalReceiver,
                  onSetFieldIndex: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setFieldIndex(6)))
                }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhone", "onSetErrorPhoneCode", "disabled", "onSetErrorCharMinimal"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            label: "Alamat Pengirim",
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: _ctx.handleDisabledInput,
                type: "textarea",
                error: _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[7],
                "error-caption": 
              _ctx.errorMandatory[6]
                ? 'Alamat pengirim wajib diisi'
                : 'Alamat pengirim dan penerima tidak boleh sama'
            ,
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentSenderAddress,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentSenderAddress = $event)),
                placeholder: "Masukan alamat pengirim",
                maxLength: _ctx.maxAddressLength,
                showMaxLength: true,
                onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setFieldIndex(7)))
              }, null, 8, ["disabled", "error", "error-caption", "format", "modelValue", "maxLength"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Alamat Penerima",
            asterisk: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: 
              _ctx.isShipmentCASameday
                ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddressKeeped
                    .length
                : _ctx.handleDisabledInput
            ,
                type: "textarea",
                error: _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[8],
                "error-caption": 
              _ctx.errorMandatory[8]
                ? 'Alamat penerima wajib diisi'
                : 'Alamat pengirim dan penerima tidak boleh sama'
            ,
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddress,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddress = $event)),
                placeholder: "Masukan alamat penerima",
                maxLength: _ctx.maxAddressLength,
                showMaxLength: true,
                onFocus: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setFieldIndex(8)))
              }, null, 8, ["disabled", "error", "error-caption", "format", "modelValue", "maxLength"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                  return (_openBlock(), _createBlock("label", {
                    key: index,
                    class: 
                  _ctx.isErrorSelectAddressType ? 'radioCustomError' : 'radioCustom'
                
                  }, [
                    _createVNode("input", {
                      type: "radio",
                      value: _ctx.shipmentList[_ctx.indexElement].sttRecipientAddressType,
                      checked: 
                    _ctx.shipmentList[_ctx.indexElement].sttRecipientAddressType ===
                      item.value
                  ,
                      id: item,
                      onChange: ($event: any) => (_ctx.onSelectAddressType(item.name, item.value)),
                      name: "radio-input",
                      class: "w-full whitespace-no-wrap my-2 z-10"
                    }, null, 40, ["value", "checked", "id", "onChange"]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_Icons, {
                        name: item.name === 'Rumah' ? 'home-type' : 'office',
                        class: "cursor-pointer ml-2 h-6"
                      }, null, 8, ["name"]),
                      _createVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                    ])
                  ], 2))
                }), 128))
              ]),
              _withDirectives(_createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.addressType")), 1)
              ], 512), [
                [_vShow, _ctx.isErrorSelectAddressType]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_DataWrapper, {
            label: "Kecamatan, Kota Asal",
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                class: "my-2",
                modelValue: _ctx.origin.name,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.origin.name = $event)),
                disabled: "",
                error: _ctx.errorEmbargo.originCity
              }, null, 8, ["modelValue", "error"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Kecamatan, Kota Tujuan",
            asterisk: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                isDisabled: 
              _ctx.handleDisabledInput &&
                _ctx.destination &&
                _ctx.destination.id !== 0 &&
                !_ctx.isHaveChosen
            ,
                class: "my-2",
                onFilter: _ctx.fetchDestinationCity,
                isLoading: _ctx.isLoadingDestinationCity,
                options: _ctx.destinationCityList,
                keyName: "name",
                keyValue: "id",
                placeholder: "Ketik atau pilih alamat tujuan",
                modelValue: _ctx.destination.name,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.destination.name = $event)),
                onChange: _ctx.setDestination,
                onFocus: _cache[25] || (_cache[25] = 
              () => {
                _ctx.fetchDestinationCity(_ctx.detailShipment.destination.name);
                _ctx.setFieldIndex(9);
              }
            ),
                isShowErrorIndicator: 
              _ctx.errorDestinationCity ||
                _ctx.errorEmbargo.destinationCity ||
                _ctx.destinationErrorDFOD ||
                _ctx.errorMandatory[9]
            ,
                errorCaption: 
              _ctx.errorMandatory[9]
                ? 'Kecamatan, Kota Tujuan wajib diisi'
                : _ctx.destinationErrorDFOD
                ? _ctx.errorMsgDestinationDfod
                : ''
            ,
                isShowErrorMessage: false
              }, null, 8, ["isDisabled", "onFilter", "isLoading", "options", "modelValue", "onChange", "isShowErrorIndicator", "errorCaption"]),
              (_ctx.isVendorNinja)
                ? (_openBlock(), _createBlock(_component_ErrorMessageBooking, {
                    key: 0,
                    type: 
              _ctx.destination?.name?.type?.toLowerCase() === 'vendor_lanjutan'
                ? 'lanjutan'
                : ''
            ,
                    isValid: _ctx.isVendorNinjaValid
                  }, null, 8, ["type", "isValid"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createVNode(_component_WarningSlaTransportation, _mergeProps(_ctx.estimateSla, { class: "mt-1" }), null, 16), [
          [_vShow, _ctx.isShowWarningSla]
        ]),
        (_ctx.isPostalCodeFieldShow)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_DataWrapper, {
                  label: "Kode Pos",
                  asterisk: "",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      serverSide: false,
                      onFocus: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setFieldIndex(9.5))),
                      onFilter: _ctx.setPostalCodeDestination,
                      placeholder: "Masukan kode pos",
                      class: "mt-2",
                      keyName: "name",
                      keyValue: "id",
                      options: _ctx.postalCodeDestinationOptions,
                      modelValue: _ctx.shipmentList[_ctx.indexElement].postalCodeDestination,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].postalCodeDestination = $event)),
                      isShowErrorIndicator: 
                _ctx.currentFieldIndex > 9.5 &&
                  !_ctx.shipmentList[_ctx.indexElement].postalCodeDestination
              ,
                      errorCaption: 
                _ctx.currentFieldIndex > 9.5 &&
                !_ctx.shipmentList[_ctx.indexElement].postalCodeDestination
                  ? 'Kode Pos wajib diisi'
                  : ''
              
                    }, null, 8, ["onFilter", "options", "modelValue", "isShowErrorIndicator", "errorCaption"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_Checkbox, {
                id: "sender",
                modelValue: _ctx.isSaveSender,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.isSaveSender = $event)),
                binary: true,
                onFocus: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onSaveCustomer($event, 'sender'))),
                disabled: _ctx.disableSaveSender || _ctx.handleDisabledInput
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("label", {
                class: "ml-2.5",
                for: "sender",
                style: 
                `${
                  _ctx.disableSaveSender || _ctx.handleDisabledInput
                    ? `color:#9e9e9e`
                    : ''
                }`
              
              }, "Simpan Data Pengirim", 4)
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_Checkbox, {
                id: "receiver",
                modelValue: _ctx.isSaveReceiver,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.isSaveReceiver = $event)),
                binary: true,
                onFocus: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onSaveCustomer($event, 'receiver'))),
                disabled: _ctx.disableSaveReceiver || _ctx.handleDisabledInput
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("label", {
                class: "ml-2.5",
                for: "receiver",
                style: 
                `${
                  _ctx.disableSaveReceiver || _ctx.handleDisabledInput
                    ? `color:#9e9e9e`
                    : ''
                }`
              
              }, "Simpan Data Penerima", 4)
            ])
          ])
        ]),
        _hoisted_26,
        _createVNode(_component_Title, { label: "Detail Barang" }),
        _createVNode(_component_BannerProductType, { class: "mt-8" }),
        _createVNode(_component_DataWrapper, {
          label: "Jenis Pengiriman",
          asterisk: "",
          class: "w-full mr-4 mt-2"
        }, {
          default: _withCtx(() => [
            (_ctx.isEmbargoCommodity)
              ? (_openBlock(), _createBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _hoisted_29
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_product_poster, {
              class: "mt-3",
              ref: "renderPoster",
              productType: 
            _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() === 'jumbopackh2h' ? 'jumbopack': _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase()
          ,
              isDisabledProduct: _ctx.isDisableProduct,
              onChoseeProduct: _ctx.onSelectProduct,
              onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
              isOnePack: true,
              isShipmentCod: _ctx.isShipmentCod,
              isJumboPack: 
            (_ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() ===
              'jumbopack' || _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() ===
              'jumbopackh2h')
          ,
              isSameday: _ctx.isShipmentCASameday
            }, null, 8, ["productType", "isDisabledProduct", "onChoseeProduct", "onSetErrorTriggered", "isShipmentCod", "isJumboPack", "isSameday"]),
            (_ctx.errorProduct)
              ? (_openBlock(), _createBlock("div", _hoisted_30, [
                  _createVNode(_component_Icons, {
                    name: "warning-triangle",
                    class: " w-4"
                  }),
                  _createVNode("p", _hoisted_31, _toDisplayString(_ctx.errorProduct), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.productErrorDFOD)
              ? (_openBlock(), _createBlock("div", _hoisted_32, [
                  _createVNode(_component_Icons, {
                    name: "warning-triangle",
                    class: " w-4"
                  }),
                  _createVNode("p", _hoisted_33, _toDisplayString(_ctx.errorMsgProductDfod), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_34, [
          _createVNode(_component_DataWrapper, {
            label: "Komoditas",
            asterisk: "",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-2",
                isDisabled: _ctx.enabledCommodityT1B1B2 ? false : _ctx.handleDisabledInput,
                options: _ctx.commodities,
                onFilter: _ctx.fetchCommodityList,
                keyName: "name",
                keyValue: "code",
                placeholder: "Ketik atau pilih nama komoditas",
                modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentCommodityName,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentCommodityName = $event)),
                isShowErrorMessage: false,
                isShowErrorIndicator: 
              _ctx.isErrorCommodity || _ctx.errorEmbargo.comodity || _ctx.errorMandatory[10]
            ,
                errorCaption: 
              _ctx.isErrorCommodity
                ? `Komoditas ini tidak aktif`
                : _ctx.errorMandatory[10]
                ? `Komoditas wajib diisi`
                : ''
            ,
                onFocus: _cache[33] || (_cache[33] = ($event: any) => (_ctx.setFieldIndex(10))),
                onChange: _cache[34] || (_cache[34] = 
              ($event) => {
                _ctx.checkIsEmbargo($event);
                _ctx.onUpdateEmbargoStatusFail();
                _ctx.setHwsCommodity();
                _ctx.checkIsEmbargo();
              }
            )
              }, null, 8, ["isDisabled", "options", "onFilter", "modelValue", "isShowErrorIndicator", "errorCaption"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Asuransi",
            tooltipTitle: "Asuransi",
            tooltipDescription: "Asuransi akan memproteksi barang yang rusak/hilang sesuai dengan S&K yang berlaku. Biaya asuransi akan otomatis terakumulasi pada Total Tarif.",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                isDisabled: !_ctx.isShipmentInsuranceEnable || _ctx.disabledInsurance,
                onOpenSelect: 
              () => {
                _ctx.onOpenSelectInsurance();
                _ctx.setFieldIndex(12);
              }
            ,
                onCloseSelect: _ctx.onCloseSelectInsurance,
                isOpenMenu: _ctx.isOpenSelectInsurance,
                value: _ctx.shipmentList[_ctx.indexElement].shipmentInsurance,
                onChooseSelect: _ctx.onSelectStatusInsurance,
                dataSelect: _ctx.listInsurance,
                isError: _ctx.error.insurance || _ctx.errorMandatory[12],
                class: "w-full whitespace-no-wrap my-2 z-10"
              }, null, 8, ["isDisabled", "onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError"]),
              (_ctx.error.insurance || _ctx.errorMandatory[12])
                ? (_openBlock(), _createBlock("p", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(_ctx.errorMandatory[12]
                ? "Asuransi wajib diisi"
                : "Asuransi tidak aktif"), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_37, [
          _createVNode(_component_DataWrapper, {
            label: "No. Registrasi Pajak (NPWP)",
            tooltipTitle: "No. Registrasi Pajak (NPWP)",
            tooltipDescription: "Wajib Pajak bisa individu atau perusahaan sesuai dengan yang sudah terdaftar.",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: _ctx.handleDisabledInput,
                modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentNpwpNumber,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentNpwpNumber = $event)),
                format: _ctx.formatted,
                onChange: _ctx.validateTaxNumber,
                errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                error: _ctx.error.taxNumber,
                placeholder: "00.000.000.0-000.000",
                maxLength: "20",
                "show-max-length": "",
                onBlur: _ctx.handleErrorTaxNumber,
                onFocus: _cache[36] || (_cache[36] = ($event: any) => (_ctx.setFieldIndex(14)))
              }, null, 8, ["disabled", "modelValue", "format", "onChange", "error", "onBlur"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Status Pengiriman",
            optional: "",
            tooltipTitle: "Status Pengiriman",
            tooltipDescription: "Status pengiriman berlaku untuk pengiriman dari Kota Asal FTZ. Isi dengan kondisi barang yang akan dikirimkan.",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                onOpenSelect: 
              () => {
                _ctx.onOpenSelect();
                _ctx.setFieldIndex(11);
              }
            ,
                onCloseSelect: _ctx.onCloseSelect,
                isOpenMenu: _ctx.isStatusGoods,
                value: _ctx.shipmentList[_ctx.indexElement].shipmentGoodsStatus,
                onChooseSelect: _ctx.onSelectStatus,
                dataSelect: _ctx.listStatusGoods,
                class: "w-full whitespace-no-wrap my-1.5 z-10",
                isError: _ctx.errorMandatory[11],
                isDisabled: false
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError"]),
              (_ctx.errorMandatory[11])
                ? (_openBlock(), _createBlock("p", _hoisted_38, [
                    _hoisted_39,
                    _hoisted_40
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_41, [
          _createVNode("div", _hoisted_42, [
            _createVNode(_component_DataWrapper, {
              label: "Harga Barang",
              asterisk: _ctx.shipmentList[_ctx.indexElement].shipmentInsurance !== 'free',
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentGoodsPriceEstimation,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentGoodsPriceEstimation = $event)),
                  prefix: "IDR",
                  format: _ctx.formatEstimationPrice,
                  onKeydown: _cache[38] || (_cache[38] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  disabled: _ctx.estimastionColumnDisable || _ctx.handleDisabledInput,
                  placeholder: "e.g 20.000",
                  onChange: _ctx.fullFilledCOD,
                  errorIcon: false,
                  error: _ctx.errorMandatory[13] || _ctx.errorEstimationPrice,
                  errorCaption: 
                _ctx.errorEstimationPrice
                  ? `${_ctx.errMsgPrice}`
                  : 'Harga barang wajib diisi'
              ,
                  onFocus: _cache[39] || (_cache[39] = ($event: any) => (_ctx.setFieldIndex(13)))
                }, null, 8, ["modelValue", "format", "disabled", "onChange", "error", "errorCaption"])
              ]),
              _: 1
            }, 8, ["asterisk"])
          ])
        ]),
        _createVNode(_component_Woodpacking, {
          ref: "woodpacking",
          modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentIsWoodpacking,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentIsWoodpacking = $event)),
          city: _ctx.cityForWoodPacking,
          isDisabled: "",
          eligibleAccessForShipment: _ctx.woodpackingAccess
        }, null, 8, ["modelValue", "city", "eligibleAccessForShipment"]),
        _createVNode("div", _hoisted_43, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryFeeTypes, (option) => {
            return (_openBlock(), _createBlock("div", {
              key: option.value,
              class: "flex flex-col gap-y-4 mx-2 my-4 city-exclude-radio items-center"
            }, [
              _createVNode("div", {
                class: 
              `p-field-radiobutton gap-x-3 flex flex-row ${
                option.logo ? 'items-center' : 'mt-3'
              }
            ${option.logo === 'dfod-logo' ? 'mt-2' : ''}`
            
              }, [
                _createVNode(_component_RadioButton, {
                  id: `radio-${option.value}`,
                  name: "surcharge-status",
                  value: option.value,
                  modelValue: _ctx.shipmentList[_ctx.indexElement].codDfodValue,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].codDfodValue = $event)),
                  disabled: option.disabled,
                  onChange: ($event: any) => (_ctx.onChangeDeliveryFeeType(option.value))
                }, null, 8, ["id", "value", "modelValue", "disabled", "onChange"]),
                _createVNode("label", {
                  for: `radio-${option.value}`,
                  class: 
                `cursor-pointer flex ${option.logo ? 'items-center' : ''}`
              
                }, [
                  (option.logo)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: require(`@/app/ui/assets/images/${option.logo}.png`),
                        class: "max-w-none w-12 mr-2",
                        alt: "cod-logo"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createVNode("label", _hoisted_44, _toDisplayString(option.name), 1)
                ], 10, ["for"])
              ], 2)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_45, [
          _withDirectives(_createVNode(_component_DataWrapper, {
            label: "Harga Barang COD",
            class: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.shipmentList[_ctx.indexElement].codAmount,
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].codAmount = $event)),
                prefix: "IDR",
                disabled: _ctx.disabledInput ? _ctx.disabledInput : _ctx.isCODStatus,
                format: _ctx.formatEstimationPrice,
                onKeydown: _cache[43] || (_cache[43] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                placeholder: "0",
                disableBackground: true,
                onFocus: _cache[44] || (_cache[44] = ($event: any) => (_ctx.setFieldIndex(14))),
                error: _ctx.errorMandatory[14] || _ctx.errorEstimationPrice,
                errorCaption: 
              _ctx.errorEstimationPrice && _ctx.isEligibleCOD ? `${_ctx.errMsgPrice}` : ''
            
              }, null, 8, ["modelValue", "disabled", "format", "error", "errorCaption"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.shipmentList[_ctx.indexElement].codDfodValue === 'cod']
          ]),
          _createVNode("div", _hoisted_46, [
            _withDirectives(_createVNode(_component_InformationCodRetail, {
              type: _ctx.shipmentList[_ctx.indexElement].codDfodValue,
              booking: "ca",
              class: "max-h-full"
            }, null, 8, ["type"]), [
              [_vShow, 
              _ctx.shipmentList[_ctx.indexElement].codDfodValue !== 'non-cod' &&
                _ctx.isShipmentFavorite
            ]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_47, [
          _createVNode("div", _hoisted_48, [
            _hoisted_49,
            _createVNode("div", _hoisted_50, [
              _createVNode(_component_DataWrapper, {
                label: "Berat Barang",
                suffix: "Kg",
                tooltipTitle: "Berat Barang (Kg)",
                tooltipDescription: "Minimum berat barang adalah 1 Kg. Masukan desimal dengan “,” bila dibutuhkan.",
                isDefault: false
              })
            ]),
            _hoisted_51,
            _hoisted_52,
            _hoisted_53
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "flex flex-col"
            }, [
              _createVNode("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, _toDisplayString(index + 1), 1),
                _createVNode("div", _hoisted_56, [
                  _createVNode(_component_lp_input, {
                    modelValue: key.grossWeight,
                    "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), _ctx.setValidateHWS],
                    error: _ctx.errorEmbargo.weightStatus,
                    format: _ctx.formatFloat,
                    onChange: ($event: any) => (_ctx.onUpdateEmbargoStatusFail($event, index)),
                    placeholder: "e.g 20",
                    maxLength: _ctx.isMaxLengthGrossWeight,
                    isErrorIconInput: false,
                    isErrorIconCaption: false,
                    disabled: 
                  _ctx.isPrintAble ||
                    _ctx.isShipmentMp ||
                    _ctx.configDisableC1 ||
                    _ctx.disabledWeightAdjustment ||
                    _ctx.isShipmentCASameday
                ,
                    onFocus: _cache[45] || (_cache[45] = ($event: any) => (_ctx.setFieldIndex(14))),
                    onOnClickViewDisabledInput: ($event: any) => (_ctx.onClickWeightAdjustment(index)),
                    showViewDisabledInput: _ctx.disabledWeightAdjustment
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "format", "onChange", "maxLength", "disabled", "onOnClickViewDisabledInput", "showViewDisabledInput"])
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode(_component_InputDimension, {
                    length: key.dimension.length,
                    "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                    width: key.dimension.width,
                    "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                    height: key.dimension.height,
                    "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                    onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                    onOnClickViewDisabledInput: ($event: any) => (_ctx.onClickWeightAdjustment(index)),
                    disabled: 
                  _ctx.isPrintAble ||
                    key.isDimensionDisabled ||
                    _ctx.isShipmentMp ||
                    _ctx.configDisableC1 ||
                    _ctx.disabledWeightAdjustment ||
                    _ctx.isShipmentCASameday
                ,
                    error: _ctx.errorEmbargo.lengthStatus,
                    withIcon: false,
                    errorCaption: "Berat melebihi batas",
                    onChange: _ctx.onUpdateEmbargoStatusFail,
                    onFocus: _cache[46] || (_cache[46] = ($event: any) => (_ctx.setFieldIndex(14))),
                    showViewDisabledInput: _ctx.disabledWeightAdjustment
                  }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "onOnClickViewDisabledInput", "disabled", "error", "onChange", "showViewDisabledInput"])
                ]),
                _createVNode("div", _hoisted_58, _toDisplayString(key.convertVolumeWeight) + " Kg ", 1),
                _createVNode("div", _hoisted_59, [
                  _withDirectives(_createVNode("div", {
                    onClick: ($event: any) => (_ctx.removeKGs(index)),
                    class: "self-center cursor-pointer ml-3 relative"
                  }, [
                    _createVNode("div", {
                      class: "h-4 xxl:h-5 ml-2 img-close-icon",
                      onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                      onMouseleave: _cache[47] || (_cache[47] = ($event: any) => (_ctx.isHoverDelete = false))
                    }, [
                      _withDirectives(_createVNode(_component_Tooltip, {
                        message: "Hapus Barang",
                        title: "",
                        footer: "",
                        style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                      }, null, 512), [
                        [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                      ])
                    ], 40, ["onMouseenter"])
                  ], 8, ["onClick"]), [
                    [_vShow, 
                  _ctx.listKGs.length > 1 &&
                    (!_ctx.isShipmentCASameday
                      ? !_ctx.isVendorNinja &&
                        !_ctx.isShipmentMp &&
                        !_ctx.isEnablePiecesBooking &&
                        !_ctx.configDisableC1
                      : false)
                ]
                  ])
                ])
              ]),
              _withDirectives(_createVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode("div", _hoisted_62, [
                  _createVNode(_component_Icons, {
                    width: "16",
                    height: "16",
                    name: "announce",
                    class: "mr-2"
                  }),
                  _createVNode("p", _hoisted_63, " Berat diatas " + _toDisplayString(_ctx.minimumHeavyWeightSurcharge.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
                ]),
                _hoisted_64
              ], 512), [
                [_vShow, key.warningHwsSingle]
              ]),
              _withDirectives(_createVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createVNode("p", _hoisted_69, " Berat mulai " + _toDisplayString(_ctx.minimumHeavyWeightSurcharge.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
                ]),
                _hoisted_70
              ], 512), [
                [_vShow, key.isErrorHws]
              ]),
              _withDirectives(_createVNode("hr", _hoisted_71, null, 512), [
                [_vShow, index > 0 || index == _ctx.listKGs.length - 1]
              ])
            ]))
          }), 128))
        ]),
        (_ctx.errorMessageChWeight)
          ? (_openBlock(), _createBlock("div", _hoisted_72, [
              _hoisted_73,
              (_ctx.isErrorMaxChWeightGoods || _ctx.isErrorMaxChWeightDimension)
                ? (_openBlock(), _createBlock("span", _hoisted_74, " Total berat melebihi batas maksimum. Cek & atur ulang berat. "))
                : (_openBlock(), _createBlock("span", _hoisted_75, " Berat kotor sudah melebihi batas berat, Anda tidak bisa ubah berat lagi. "))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isShipmentCASameday && _ctx.totalChargeableWeight > 5)
          ? (_openBlock(), _createBlock("div", _hoisted_76, [
              _hoisted_77,
              _hoisted_78
            ]))
          : _createCommentVNode("", true),
        (
          !_ctx.isShipmentCASameday
            ? _ctx.isMaxAddKgs &&
              !_ctx.isVendorNinja &&
              !_ctx.allowToAddMoreKoli &&
              !_ctx.allowToAddMoreKoliVolume &&
              !_ctx.isShipmentMp &&
              !_ctx.configDisableC1
            : false
        )
          ? (_openBlock(), _createBlock("div", _hoisted_79, [
              _createVNode("div", {
                onClick: _cache[48] || (_cache[48] = ($event: any) => (
            _ctx.isDisableAdjustPieces || _ctx.disableAddPiecesHws ? null : _ctx.addKGs()
          )),
                class: 
            `flex gap-3 ${
              _ctx.isDisableAdjustPieces || _ctx.disableAddPiecesHws
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-red-lp-300 cursor-pointer'
            }`
          
              }, [
                _createVNode(_component_Icons, {
                  name: "plus-circle",
                  class: 
              `${
                _ctx.isDisableAdjustPieces || _ctx.disableAddPiecesHws
                  ? 'text-gray-lp-600'
                  : 'text-red-lp-300'
              }`
            
                }, null, 8, ["class"]),
                _hoisted_80
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (
          _ctx.onShowSectionAdjustmentWeight(
            _ctx.isCourierRecommendation
              ? _ctx.detailShipment.shipmentNoRefExt
              : _ctx.detailShipment.shipmentAlgoId
          ) &&
            _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() !==
              'sameday'
        )
          ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
              key: 4,
              ref: "section-weight-adjustment",
              showViewAdjustment: _ctx.showViewAdjustment,
              "onUpdate:showViewAdjustment": _cache[49] || (_cache[49] = ($event: any) => (_ctx.showViewAdjustment = $event)),
              title: "Upload bukti foto untuk ubah berat",
              watermark: 
          _ctx.isCourierRecommendation
            ? _ctx.detailShipment.shipmentNoRefExt
            : _ctx.detailShipment.shipmentAlgoId
        ,
              modelValue: _ctx.attachmentImages,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.attachmentImages = $event)),
              onOnUploadImage: _ctx.onUpload,
              onOnDeleteImage: _ctx.onRemove
            }, null, 8, ["showViewAdjustment", "watermark", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: 
          `${
            _ctx.error.maxTotalGrossWeight ||
            _ctx.isVendorNinja ||
            _ctx.error.maxTotalVolumeWeight
              ? 'border-red-lp-700 border bg-gray-lp-700 my-4 p-3 rounded-md'
              : 'my-4 bg-gray-lp-700 p-3 rounded-md'
          } text-black-lp-300`
        
        }, [
          _createVNode("div", _hoisted_81, [
            _createVNode("div", _hoisted_82, [
              _hoisted_83,
              _createVNode("p", null, _toDisplayString(_ctx.listKGs.length), 1)
            ]),
            _createVNode("div", _hoisted_84, [
              _createVNode("div", {
                class: 
                `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                  _ctx.isGrossWeight && !_ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
              }, [
                _hoisted_85,
                _createVNode("p", null, _toDisplayString(_ctx.totalGrossWeight) + " Kg", 1)
              ], 2),
              _withDirectives(_createVNode("div", _hoisted_86, [
                _hoisted_87
              ], 512), [
                [_vShow, _ctx.error.maxTotalGrossWeight]
              ]),
              _withDirectives(_createVNode("div", {
                class: 
                `flex flex-row justify-between text-12px xxl:text-14px ${
                  _ctx.isGrossWeight && _ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
              }, [
                _hoisted_88,
                _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " Kg ", 1)
              ], 2), [
                [_vShow, _ctx.isGrossWeight && _ctx.isCampaign]
              ])
            ]),
            _createVNode("div", _hoisted_89, [
              _createVNode("div", {
                class: 
                `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                  _ctx.isVolumeWeight && !_ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
              }, [
                _hoisted_90,
                _createVNode("p", null, _toDisplayString(_ctx.totalVolumeWeight) + " Kg", 1)
              ], 2),
              _withDirectives(_createVNode("div", _hoisted_91, [
                _hoisted_92
              ], 512), [
                [_vShow, _ctx.error.maxTotalVolumeWeight || _ctx.validateTotalVolumeWeight]
              ]),
              _withDirectives(_createVNode("div", {
                class: 
                `flex flex-row justify-between text-12px xxl:text-14px ${
                  _ctx.isVolumeWeight && _ctx.isCampaign
                    ? 'text-gray-lp-300 font-semibold'
                    : 'text-gray-lp-600 font-normal'
                }`
              
              }, [
                _hoisted_93,
                _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " Kg ", 1)
              ], 2), [
                [_vShow, _ctx.isVolumeWeight && _ctx.isCampaign]
              ])
            ]),
            _hoisted_94,
            _createVNode("div", _hoisted_95, [
              _hoisted_96,
              _createVNode("p", null, _toDisplayString(_ctx.isCampaign
                  ? _ctx.totalCampaignChargeableWeight.toString().replace(".", ",")
                  : _ctx.totalChargeableWeight) + " Kg ", 1)
            ])
          ])
        ], 2),
        (_ctx.isFtzAccount)
          ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
              _hoisted_97,
              _createVNode(_component_Title, { label: "Free Trade Zone" }),
              _createVNode("div", _hoisted_98, [
                _createVNode("div", _hoisted_99, [
                  _createVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _hoisted_102,
                    _createVNode("div", _hoisted_103, [
                      _createVNode("img", {
                        class: "h-4 xxl:h-5 ml-2",
                        onMouseenter: _cache[51] || (_cache[51] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = true)),
                        onMouseleave: _cache[52] || (_cache[52] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = false)),
                        src: 
                    _ctx.isOpenTooltipPiecePerPack
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: "Piece Per Pack",
                        message: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
                        footer: "",
                        style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                      }, null, 512), [
                        [_vShow, _ctx.isOpenTooltipPiecePerPack]
                      ])
                    ])
                  ]),
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.shipmentList[_ctx.indexElement].piecePerPack,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].piecePerPack = $event)),
                    format: _ctx.formatPiecePerPack,
                    placeholder: "Masukan piece per pack",
                    errorIcon: false,
                    error: _ctx.errorMandatory[16],
                    errorCaption: 'Piece per pack wajib diisi',
                    onFocus: _cache[54] || (_cache[54] = ($event: any) => (_ctx.setFieldIndex(16)))
                  }, null, 8, ["modelValue", "format", "error"])
                ]),
                _createVNode("div", _hoisted_104, [
                  _createVNode("div", _hoisted_105, [
                    _hoisted_106,
                    _hoisted_107,
                    _createVNode("div", _hoisted_108, [
                      _createVNode("img", {
                        class: "h-4 xxl:h-5 ml-2",
                        onMouseenter: _cache[55] || (_cache[55] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = true)),
                        onMouseleave: _cache[56] || (_cache[56] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = false)),
                        src: 
                    _ctx.isOpenTooltipNextCommodity
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: "Komoditas Selanjutnya",
                        message: "Isi dengan komoditas barang yang ada dalam satu koli.",
                        footer: "",
                        style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                      }, null, 512), [
                        [_vShow, _ctx.isOpenTooltipNextCommodity]
                      ])
                    ])
                  ]),
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.shipmentList[_ctx.indexElement].nextCommodity,
                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].nextCommodity = $event)),
                    placeholder: "Masukan komoditas selanjutnya",
                    error: _ctx.errorMandatory[17],
                    errorCaption: 'Komoditas selanjutnya wajib diisi',
                    onFocus: _cache[58] || (_cache[58] = ($event: any) => (_ctx.setFieldIndex(17))),
                    onBlur: _cache[59] || (_cache[59] = ($event: any) => (_ctx.setFieldIndex(18)))
                  }, null, 8, ["modelValue", "error"])
                ])
              ]),
              _hoisted_109
            ], 64))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        (_ctx.isVendorNinja)
          ? (_openBlock(), _createBlock("div", _hoisted_110, " Untuk tujuan yang dipilih maksimal 1 koli "))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_111, [
          (
            _ctx.prefixAlgoEstimationShow(
              _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId
            ) || _ctx.shipmentC1Cod
          )
            ? (_openBlock(), _createBlock(_component_DetailCalculation, {
                key: 0,
                isBooking: true,
                isDisabled: _ctx.isDisabledButton,
                bookingType: "shipment",
                payload: _ctx.payload,
                isPrintAble: _ctx.isPrintAble,
                algoId: _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId,
                onUpdateStatusErrorEmbargo: _ctx.updateStatusErrorEmbargo,
                comodityCode: _ctx.shipmentList[_ctx.indexElement].shipmentCommodityCode
              }, null, 8, ["isDisabled", "payload", "isPrintAble", "algoId", "onUpdateStatusErrorEmbargo", "comodityCode"]))
            : (_openBlock(), _createBlock(_component_DetailUncalculation, {
                key: 1,
                isBooking: true,
                isDisabled: _ctx.isDisabledButton,
                bookingType: "shipment",
                payload: _ctx.payload,
                isPrintAble: _ctx.isPrintAble,
                algoId: _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId,
                onOnSelectProduct: _ctx.mountedProductUpsellingDefault
              }, null, 8, ["isDisabled", "payload", "isPrintAble", "algoId", "onOnSelectProduct"]))
        ])
      ]),
      _: 1
    }, 8, ["title", "onClose"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.setEditTerminated(false);
        _ctx.setModalDetailShipment(false);
      }
    ,
      onClose: () => _ctx.setEditTerminated(false),
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModalError,
      title: _ctx.titleErrorspesification,
      message: _ctx.errorCause,
      image: "image-modal-warning",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
    ]),
    (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalError,
          onTryAgain: _ctx.booking,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Pembuatan Booking Baru Berhasil !",
      message: `${this.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        (_ctx.discount?.isDiscount)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              isShadow: false,
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _hoisted_112,
                _createVNode("div", _hoisted_113, [
                  _createVNode("div", _hoisted_114, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalTariff)), 1),
                  _createVNode("div", _hoisted_115, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ])
  ], 64))
}